import { Box, Button, Td, FormLabel } from '@chakra-ui/react';
import Editor from '@monaco-editor/react';
import { Formik, FormikProps } from 'formik';
import React, { useState } from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { defaultTheme, lightTheme } from '../../edit/MonacoEditor/ui/common';
import { colors } from 'packages/common-frontend/colors';
import { TrDraggableHandle } from 'packages/common-frontend/components/DragAndDropTable/ui';
import { TextInputFormField } from 'packages/common-frontend/components/FormField';

type EditIntermediateValueRowProps = {
  onCancel: Function;
  onSave: (params: {
    field: CreditAgreement.Config.CommonIntermediateField.IntermediateField;
    saveIdx: number;
    fullPropertyKey: string;
    configPropertyKey: string;
    setIsSaveLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  }) => Promise<void>;
  intermediateField: CreditAgreement.Config.CommonIntermediateField.IntermediateField;
  isDragDisabled: boolean;
  moveRow: any;
  idx: number;
  id: string;
  operationMode?: CreditAgreement.OperationMode;
  configPropertyKey: string;
  fullPropertyKey: string;
};
export const EditIntermediateValueRow = ({
  onCancel,
  onSave,
  intermediateField,
  moveRow,
  isDragDisabled,
  idx,
  id,
  operationMode,
  configPropertyKey,
  fullPropertyKey,
}: EditIntermediateValueRowProps) => {
  const [isSaving, setIsSaving] = useState(false);
  return (
    <Formik
      initialValues={{
        field: intermediateField.field,
        config: {
          formula: intermediateField.config.formula,
          engineVersion: intermediateField.config.engineVersion,
          type: intermediateField.config.type,
        },
      }}
      onSubmit={async (props) => {
        await onSave({
          field: props,
          saveIdx: idx,
          configPropertyKey,
          fullPropertyKey,
          setIsSaveLoading: setIsSaving,
        });
      }}
    >
      {(formProps: FormikProps<any>) => (
        <TrDraggableHandle
          acceptedType="intermediateCalc"
          id={id}
          index={idx}
          moveRow={moveRow}
          isDragDisabled={isDragDisabled}
        >
          <Td verticalAlign="top">
            <TextInputFormField label="Field Name" name="field" />
          </Td>
          <Td>
            <Box>
              <FormLabel>Formula</FormLabel>
              <Box
                border="1px"
                borderColor={colors.gray[200]}
                borderRadius="8px"
                p="8px"
                overflow="auto"
                height="15vh"
              >
                <Editor
                  value={formProps.values.config.formula}
                  onChange={(val) =>
                    formProps.setFieldValue('config.formula', val)
                  }
                  theme={operationMode === 'client' ? lightTheme : defaultTheme}
                  options={{
                    fixedOverflowWidgets: true,
                    minimap: { enabled: false },
                  }}
                />
              </Box>
            </Box>
          </Td>

          {isDragDisabled && (
            <Td verticalAlign="top">
              <Button
                w="100%"
                mt="28px"
                mb="16px"
                color="white"
                backgroundColor={colors.aurora[400]}
                onClick={() => {
                  formProps.handleSubmit();
                }}
                isLoading={isSaving}
              >
                Save
              </Button>
              <Button
                w="100%"
                color={colors.aurora[400]}
                border="2px"
                borderRadius="8px"
                borderColor={colors.aurora[400]}
                backgroundColor="white"
                onClick={() => onCancel()}
              >
                Cancel
              </Button>
            </Td>
          )}
        </TrDraggableHandle>
      )}
    </Formik>
  );
};
